import { createAction } from '../../utils/redux/createAction';
import { SCHEDULE_TYPES } from '../../components/ProviderCalendar/constants';

const actionsScope = 'schedule/selected-popover';

export const SELECTED_POPOVER_TYPES = {
  SET_POSITION: `${actionsScope}/set-position`,
  SET_OPTIMIZED_POSITION: `${actionsScope}/set-optimized-position`,
  SET_SELECTABLE: `${actionsScope}/set-selectable`,
  SET_TYPE: `${actionsScope}/set-type`,
  SET_BLOCKED: `${actionsScope}/set-blocked`,
  RESET: `${actionsScope}/reset`,
};

export const POPOVER_CONTENT_TYPES = {
  NEW: 'new',
  SELECT_EXISTED: 'select-existed',
  HOVER: 'hover',
  EDIT: 'edit',
  SET_NEW_BLOCKED: 'set-new-blocked',
  APPOINTMENT_DETAILS: 'appointment-details',
  APPOINTMENT_FORM: 'appointment-form',
};

export const selectedPopoverActions = {
  setPosition: createAction(SELECTED_POPOVER_TYPES.SET_POSITION),
  setOptimizedPosition: createAction(
    SELECTED_POPOVER_TYPES.SET_OPTIMIZED_POSITION,
  ),
  setSelectable: createAction(SELECTED_POPOVER_TYPES.SET_SELECTABLE),
  setType: createAction(SELECTED_POPOVER_TYPES.SET_TYPE),
  setBlocked: createAction(SELECTED_POPOVER_TYPES.SET_BLOCKED),
  reset: createAction(SELECTED_POPOVER_TYPES.RESET),
};

const initialState = {
  visible: false,
  schedule: null,
  selectable: false,
  appointmentId: null,
  type: '',
  areaBounds: {
    width: 100,
    top: 0,
    left: 0,
  },
  bounds: {
    width: 100,
    top: 0,
    left: 0,
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SELECTED_POPOVER_TYPES.SET_OPTIMIZED_POSITION: {
      const {
        schedule,
        bounds,
        type: popoverType,
        appointmentId,
        areaBounds,
      } = payload;

      return {
        ...state,
        visible: true,
        selectable: false,
        type: popoverType,
        schedule,
        areaBounds,
        bounds,
        appointmentId,
      };
    }

    case SELECTED_POPOVER_TYPES.SET_SELECTABLE: {
      return {
        ...state,
        selectable: true,
        visible: false,
      };
    }

    case SELECTED_POPOVER_TYPES.SET_BLOCKED: {
      return {
        ...state,
        type: POPOVER_CONTENT_TYPES.SET_NEW_BLOCKED,
        schedule: {
          ...state.schedule,
          isRepeatable: false,
          __type: SCHEDULE_TYPES.BLOCK,
        },
      };
    }

    case SELECTED_POPOVER_TYPES.SET_TYPE: {
      return { ...state, type: payload };
    }

    case SELECTED_POPOVER_TYPES.RESET: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/schedule/selectedPopover.js